import React from 'react'

import * as MdIcons from 'react-icons/md'
import { useTheme } from 'styled-components'

import { Container, IconContainer, Message, Title } from './styles'

export function Forbidden() {
  const theme = useTheme()

  return (
    <Container>
      <IconContainer>
        <MdIcons.MdBlock size={150} color={theme.colors.text} />
      </IconContainer>
      <Title>Forbidden</Title>
      <Message>
        You do not have permission to access the app, please contact your site
        admin.
      </Message>
    </Container>
  )
}
